module.exports = __webpack_public_path__ + "static/media/CEPILLO10CERDASPLASTICAS.42edb1b8.jpg";